import PfizerLogo from '../src/assets/logo/logo-pfizer.png';
import AttLogo from '../src/assets/logo/logo-at&t.png';
import ElphiLogo from '../src/assets/logo/logo-elphi.jpeg';
import RutgersLogo from '../src/assets/logo/logo-rutgers.jpg';
import CashcowLogo from '../src/assets/logo/logo-cashcow.jpg';
import LinkedInLogo from '../src/assets/social-linkedin.png';
import GithubLogo from '../src/assets/social-github.png';
import ProfileImage from '../src/assets/profile-image.jpeg';

export const initTiles = [
  { id: 1, type: 'rh', content: 'About - Profile' },
  { id: 2, type: 'map', content: 'About - Maps' },
  { id: 3, type: 'rv', content: 'Project - 1' },
  { id: 4, type: 'square', content: 'Square - Spotify' },
  { id: 5, type: 'square', content: 'About - LinkedIn' },
  { id: 6, type: 'rv', content: 'Project - 2' },
  { id: 7, type: 'rh', content: 'Personal History' },
  { id: 8, type: 'square', content: 'Night Mode' },
  { id: 9, type: 'rh', content: 'Project - 3' },
  { id: 10, type: 'rh', content: 'Contacts' },
];
export const aboutTiles = [
  { id: 1, type: 'rh', content: 'About - Profile' },
  { id: 2, type: 'map', content: 'About - Maps' },
  { id: 5, type: 'square', content: 'About - LinkedIn' },
  { id: 4, type: 'square', content: 'Square - Spotify' },
  { id: 8, type: 'square', content: 'Night Mode' },
  { id: 6, type: 'rv', content: 'Project - 2' },
  { id: 3, type: 'rv', content: 'Project - 1' },
  { id: 7, type: 'rh', content: 'Personal History' },
  { id: 9, type: 'rh', content: 'Project - 3' },
  { id: 10, type: 'rh', content: 'Contacts' },
];
export const projectTiles = [
  { id: 9, type: 'rh', content: 'Project - 3' },
  { id: 6, type: 'rv', content: 'Project - 2' },
  { id: 3, type: 'rv', content: 'Project - 1' },
  { id: 1, type: 'rh', content: 'About - Profile' },
  { id: 4, type: 'square', content: 'Square - Spotify' },
  { id: 8, type: 'square', content: 'Night Mode' },
  { id: 2, type: 'map', content: 'About - Maps' },
  { id: 5, type: 'square', content: 'About - LinkedIn' },
  { id: 7, type: 'rh', content: 'Personal History' },
  { id: 10, type: 'rh', content: 'Contacts' },
];
export const mediaTiles = [
  { id: 7, type: 'rh', content: 'Personal History' },
  { id: 10, type: 'rh', content: 'Contacts' },
  { id: 4, type: 'square', content: 'Square - Spotify' },
  { id: 2, type: 'map', content: 'About - Maps' },
  { id: 6, type: 'rv', content: 'Project - 2' },
  { id: 3, type: 'rv', content: 'Project - 1' },
  { id: 9, type: 'rh', content: 'Project - 3' },
  { id: 1, type: 'rh', content: 'About - Profile' },
  { id: 8, type: 'square', content: 'Night Mode' },
  { id: 5, type: 'square', content: 'About - LinkedIn' },
];

export const backgroundImage = {
  project1: 'https://nevflynn.com/images/recroot-bg.svg',
  project2: 'https://nevflynn.com/images/vouch-for-bg.svg',
  project3: 'https://nevflynn.com/images/wrap-bg.svg',
};

export const profileImage = ProfileImage;
export const companyLogo = {
  pfizer: PfizerLogo,
  cashcow: CashcowLogo,
  att: AttLogo,
  elphi: ElphiLogo,
  rutgers: RutgersLogo,
};

export const experienceDetails = [
  {
    companyName: 'Pfizer',
    location: 'New York, NY',
    logo: companyLogo.pfizer,
    title: 'Software Engineer II',
    duration: 'May 2021 - Present',
    description: [
      'At Pfizer, I’ve driven transformative digital solutions by developing 23 scalable web libraries using Next.js, TypeScript, and Angular. These libraries streamlined code reuse and delivered responsive, high-performance experiences for millions of users worldwide. My focus on optimization reduced webpage load times by 6 seconds through advanced techniques like Webpack, Babel, and server-side rendering—ensuring seamless interactions and boosting user satisfaction.',

      'Working in an Agile, test-driven environment, I implemented Jest and React Testing Library to establish robust testing frameworks, ensuring reliable, predictable applications. I also revamped the CI/CD pipeline with GitHub Actions, enabling rapid, consistent deployments and reducing release cycles to meet business demands efficiently.',

      'A key highlight was transitioning APIs from REST to GraphQL, improving data retrieval efficiency, shrinking payload sizes, and enhancing system performance. By consolidating web applications into a single monorepo with NX and migrating codebases to TypeScript, I improved scalability, maintainability, and cross-team collaboration.',

      'Beyond engineering, my work directly impacted business outcomes. A dynamic Node.js cron job I built boosted targeted marketing performance by 40%, while Redis caching and optimized GraphQL resolvers cut API response times by 35%, driving a 15% increase in personalized engagement. Additionally, I integrated a partner’s API with JWT authentication and Splunk monitoring, reducing errors by 40% and ensuring compliance with stringent security standards.',

      'With a focus on accessibility, I optimized platforms to meet industry standards, delivering inclusive experiences for all users. Leveraging AWS tools like S3, ECS, and DynamoDB, I ensured secure, scalable deployments, aligning technical excellence with Pfizer’s mission of making a global impact.',
    ],
    technologies: [
      'Next.js',
      'TypeScript',
      'Angular',
      'Node.js',
      'Express.js',
      'GraphQL',
      'REST APIs',
      'Jest',
      'React Testing Library',
      'Webpack',
      'Babel',
      'AWS',
      'JSON-Rule-Engine',
    ],
  },
  {
    companyName: 'Elphi',
    location: 'New York, NY',
    logo: companyLogo.elphi,
    title: 'Full Stack Developer',
    duration: 'Jan 2020 - Dec 2020',
    description: [
      'During my internship at Elphi Inc., I had the opportunity to transform their user-facing digital experience. I spearheaded the revamp of the company’s landing page, transitioning it from a static form to a dynamic, interactive system with custom React hooks and Redux-based form handling. This upgrade not only enhanced user experience but also reduced drop-offs by 35%, generating over 600 new leads—a tangible impact on business growth.',

      'To standardize and streamline development efforts, I designed and implemented a reusable component library based on Atomic Design principles. This initiative unified UI elements across the platform, improved code reusability by 40%, and accelerated feature delivery by cutting UI development time by 30%. It became a cornerstone for future development, enabling the team to deliver consistent and polished user interfaces more efficiently.',

      'Accessibility was another critical focus of my role. By identifying and resolving over five key accessibility gaps in collaboration with developers, I helped align the platform with WCAG standards. These efforts ensured a more inclusive experience for users relying on assistive technologies, significantly improving their satisfaction and usability of the platform.',

      'On the backend, I contributed to the stability and efficiency of the system by enhancing data cleanup and user engagement tracking jobs. Through optimized query handling and robust error reporting, I reduced job failures by 30%, resulting in more reliable analytics and smoother operations. Additionally, I integrated Git-based version control into Elphi’s CI/CD pipeline, enforcing code quality checks and automating testing processes. This not only reduced deployment errors by 20% but also improved team collaboration and ensured smoother, faster delivery cycles.',

      'My time at Elphi Inc. allowed me to drive meaningful improvements across the stack—from frontend user experience to backend reliability—while building systems that were not only efficient but also scalable, inclusive, and user-focused.',
    ],
    technologies: [
      'React',
      'Redux',
      'Atomic Design Principles',
      'WCAG Standards',
      'Git (Version Control)',
      'CI/CD Pipeline',
      'Automated Testing',
      'Error-Validated Systems',
      'Query Optimization',
    ],
  },
  {
    companyName: 'AT&T',
    logo: companyLogo.att,
    title: 'Software Engineer',
    duration: 'Jan 2019 - Dec 2019',
    description: [
      "Let's dive into my gig at AT&T, where I was working remotely as an Extern for a couple of months in the summer of 2020. It was a whirlwind of collaboration and problem-solving!",

      "So, picture this: I'm in the virtual trenches, working hand-in-hand with UX wizards, product pros, and the QA crew to cook up some seriously slick features and articles for the streaming platform. It was all about keeping things on-brand and running like a well-oiled machine.",

      "One of my proudest moments? Implementing this killer form validation feature. We're talking about making sure every input aligns perfectly with the schema – and boy, did it pay off! Human error? Cut down by a whopping 80%. Now, that's what I call a win!",

      "But hey, it wasn't all smooth sailing. Bugs were popping up left and right, but I was on the case. On average, I was squashing about 15 pesky bugs every month, which did wonders for boosting platform stability by 20%.",

      "Tech-wise, it was a mixed bag of goodies – React for the frontend magic, HTML and CSS for the styling fun, and a sprinkle of JavaScript for that extra flair. And of course, we couldn't forget about making sure everything was tip-top in terms of accessibility, so WCAG was always front and center.",

      'All in all, it was a short but sweet stint at AT&T – filled with challenges, victories, and plenty of learning along the way.',
    ],
    technologies: [
      'React',
      'HTML',
      'CSS',
      'SASS/SCSS',
      'JavaScript',
      'WACG',
      'Figma',
    ],
  },
  {
    companyName: 'Rutgers University',
    logo: companyLogo.rutgers,
    title: 'Adjunct Professor',
    duration: 'Sep 2019 - Dec 2020',
    description: [
      'At Rutgers University, I had the privilege of shaping the next generation of software engineers by teaching core concepts like Object-Oriented Programming & Design, asynchronous programming, web app development, and version control. Over the course of the year, I guided more than 500 students, turning complex technical topics into accessible, engaging lessons tailored to a diverse range of skill levels and backgrounds.',

      'My role went beyond lectures—I led weekly recitations for 120 students, diving deep into course material and facilitating hands-on exercises to solidify their understanding. These interactive sessions bridged the gap between theory and practice, empowering students to tackle real-world programming challenges with confidence.',

      'A key highlight of my tenure was evaluating React-based web development projects and exams for 16 cohorts. I provided detailed, constructive feedback to help students refine their skills and elevate their work. Whether reviewing code or troubleshooting logic, my goal was always to foster a growth mindset and cultivate an environment where students felt supported and inspired.',

      'Teaching at Rutgers was as much about communication as it was about technology. I honed the art of translating advanced technical concepts into digestible, relatable content, ensuring that every student—whether a beginner or advanced programmer—left my classroom with newfound clarity and confidence in their abilities.',
    ],
    technologies: [
      'Object-Oriented Programming',
      'Asynchronous Programming',
      'Web App Development',
      'Version Control',
      'React',
      'Teaching & Mentorship',
    ],
  },
  {
    companyName: 'Cashcow',
    logo: companyLogo.cashcow,
    title: 'Software Engineer I',
    duration: 'Apr 2017 - Sep 2019',
    description: [
      'At Cashcow, I was driven by the challenge of simplifying complex workflows and delivering seamless user experiences. One of my key achievements was engineering a .NET Core web tool using C#, Entity Framework, Bootstrap, and JavaScript. This tool revolutionized data manipulation and validation processes, reducing what once took two full days of manual effort to just 20 minutes—an achievement that directly boosted team efficiency and freed resources for higher-value tasks.',

      'Performance optimization was a core focus of my role. I overhauled query execution between a log aggregator and SQL Server, leveraging asynchronous C# methods, refined Entity Framework calls, and optimized data indexing. This reduced query times from an hour to just five minutes, enabling faster decision-making and more responsive operations.',

      'Beyond the back-end, I recognized the importance of crafting engaging user experiences. By enhancing the interface design and overall usability of our systems, I contributed to a 10% increase in quarterly sales and improved user ratings by 0.5 points. This blend of technical excellence and user-centric design underscored my commitment to delivering impactful, business-aligned solutions.',
    ],
    technologies: [
      '.NET Core',
      'C#',
      'Javascript',
      'SQL Server',
      'Entity Framework',
      'Bootstrap',
    ],
  },
];

export const socialMedia = {
  linkedIn: {
    logo: LinkedInLogo,
    url: 'https://linkedin.com/in/hingu-parth/',
  },
  github: {
    logo: GithubLogo,
    url: 'https://github.com/hingu-parth/',
  },
};

export const history = {
  title: 'My Journey into Crafting Digital Experiences',
  content: [
    {
      phase: 'School',
      description:
        'From an early age, I was drawn to both the logic of technology and the creativity of design. In school, I found myself constantly fascinated by how things looked and functioned—whether it was sketching interfaces in my notebooks or experimenting with basic HTML and CSS to customize pages. While most of my classmates were focused on the mechanics of coding, I was just as intrigued by how digital experiences felt to the end user.',
    },
    {
      phase: 'Bachelor’s Degree',
      description:
        'This dual interest naturally led me to pursue a Bachelor’s degree in Computer Science, where I honed my programming skills while maintaining a keen eye for user experience. I spent hours learning about UI/UX principles, typography, and color theory, even outside of my core coursework. At first, frontend development seemed purely technical—just a way to bring designs to life. But as I started building real-world projects, I realized that design and frontend weren’t separate disciplines; they were deeply interconnected. The best applications weren’t just functional—they were intuitive, elegant, and seamless.',
    },
    {
      phase: 'Master’s Degree',
      description:
        "Eager to deepen this understanding, I pursued a Master’s degree, where I explored human-computer interaction (HCI), design systems, and interactive web technologies. This period was pivotal—I worked on projects that required not just writing performant code but also ensuring that interfaces were accessible, engaging, and aesthetically refined. I found immense value in the cross-section between engineering and design, realizing that a well-built frontend isn't just about implementing pixels—it’s about shaping how users experience technology.",
    },
    {
      phase: 'Professional Career',
      description:
        'Now, with 6+ years as a frontend developer, I specialize in crafting seamless React-Redux applications that don’t just work efficiently but also provide a fluid, immersive user experience. Whether it’s building scalable design systems, optimizing rendering performance, or implementing intuitive UI components, I approach frontend development as both a science and an art.',
    },
    {
      phase: 'Philosophy',
      description:
        'For me, frontend is not just about coding—it’s about crafting experiences. The intersection of design and development is where true innovation happens, and that’s where I thrive.',
    },
  ],
};

export const hari = {
  title: 'Pixels with Purpose',
  projects: [
    {
      name: 'Sambandh',
      logo: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a8/3f/a1/a83fa1de-48a7-ca09-2f11-5c8509a35c00/AppIcon-0-0-1x_U007emarketing-0-6-0-85-220.png/230x0w.webp',
      description: [
        'Three years ago, I embarked on a journey to build Sambandh, a platform that would bridge the gap between technology and tradition, empowering local individuals while fostering a deeper connection to culture. What started as an idea became a full-stack MERN application that seamlessly integrates community engagement, and spiritual connection—all in one place.',

        'As the lead UI/UX designer and frontend developer, I meticulously crafted a seamless user experience using React Native and Redux, ensuring that every interaction felt intuitive and meaningful. But Sambandh isn’t just about design; it’s about impact. By building the backend with Node.js and Express.js and integrating GraphQL for optimized data retrieval, I ensured a smooth, responsive experience that connects users with the each other.',

        'Beyond this, Sambandh serves as a digital cultural hub. Users can explore Thakorji Darshan, stay updated on upcoming events, relive past gatherings through videos, images, and shorts, and stay connected with the Hindu calendar. The donations page enables seamless contributions, helping sustain the mission and support artisans and spiritual initiatives alike.',

        'What makes this journey even more special is the team I’ve had the privilege to work with—professionals from Uber, JP Morgan, Disney, Amazon, Meta, ExodusPoint Capital Management, and more. Collaborating with some of the brightest minds in the industry has pushed the boundaries of innovation, allowing us to build a platform that is both technically robust and socially impactful.',

        'For the past three years, my work on Sambandh has been more than just development—it’s been about creating a platform with purpose. A place where technology meets tradition, empowering communities, preserving culture, and fostering deeper connections through a thoughtfully designed digital experience.',
      ],
      screenShotLinks: [
        'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/42/1a/67/421a67a5-cd52-be81-7604-5661c8b3c2ac/Simulator_Screenshot_-_iPhone_16_Pro_Max_-_2024-12-15_at_14.39.16.png/230x0w.webp',
        'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/a7/8c/2c/a78c2c76-37b8-fa02-eda1-096ccfeb93c8/IMG_3467.png/230x0w.webp',
        'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/7c/14/8e/7c148efd-c2c1-760b-ef14-f72b03819876/IMG_3470.png/230x0w.webp',
      ],
      role: {
        title: 'Lead UI/UX Designer & Frontend Developer',
        responsibilities: [
          'Designed a seamless user experience using React and Redux',
          'Developed the backend with Node.js and Express.js',
          'Integrated GraphQL for optimized data retrieval',
          'Created a smooth, responsive experience connecting users with artisans',
        ],
      },
      features: [
        'Ethical shopping platform for local artisans',
        'Thakorji Darshan for spiritual engagement',
        'Upcoming and past event details',
        'Videos, images, and shorts for community interaction',
        'Hindu calendar integration',
        'Donations page for supporting artisans and initiatives',
      ],
      team: {
        description:
          'Collaborated with a world-class team of professionals from leading companies.',
        members: [
          'Uber',
          'JP Morgan',
          'Disney',
          'Amazon',
          'Meta',
          'ExodusPoint Capital Management',
          'and more',
        ],
      },
      impact:
        'For the past three years, my work on Sambandh has been more than just development—it’s been about creating a platform with purpose. A place where technology meets tradition, empowering communities, preserving culture, and fostering deeper connections through a thoughtfully designed digital experience.',
      technologies: [
        'React',
        'Redux',
        'Node.js',
        'Express.js',
        'MongoDB',
        'GraphQL',
      ],
    },
    {
      name: 'Sampark',
      logo: 'https://sampark-dev.yds.org/static/media/sampark.cf50dcb1eab4a876b263614c0bf17a45.svg',
      technologies: [
        'React',
        'Redux',
        'Node.js',
        'Express.js',
        'GraphQL',
        'Sass',
        'Styled Components',
      ],
      description: [
        'While working on Sambandh, our mission was to connect vast network of centers and volunteers world-wide.There was a need for a dedicated digital platform to streamline everything and that’s how Sampark was born.',

        'Over the past few years, I have been developing Sampark, a React-Redux-powered web application designed to simplify and enhance operations. Built with Node.js, GraphQL, Sass, and Styled Components, Sampark enables teams to effortlessly track event details, create new events, publish articles, and post event media, all within a centralized system. By bringing automation and structure, Sampark reduces manual effort and makes management smoother and more efficient.',

        'Designed for ease of use, the platform allows devotees to schedule, organize, and oversee religious and cultural events with just a few clicks. Publishing articles and media content about these events ensures that devotees and community members stay informed and engaged. The integration of GraphQL ensures real-time data retrieval and smooth performance, while Sass and Styled Components bring a clean and visually engaging user experience.',

        'Just like Sambandh, Sampark is a testament to what happens when technology meets tradition. With a team of engineers from Uber, JP Morgan, Disney, Amazon, Meta, ExodusPoint Capital Management, and more, we’ve built a system that blends modern web development with cultural preservation.',
      ],
      screenShotLinks: [],
    },
    // {
    //   name: 'Harisumiran NJ',
    //   logo: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a8/3f/a1/a83fa1de-48a7-ca09-2f11-5c8509a35c00/AppIcon-0-0-1x_U007emarketing-0-6-0-85-220.png/230x0w.webp',
    //   technologies: ['React', 'Redux', 'Node.js', 'Express.js', 'MongoDB'],
    //   description:
    //     'Harisumiran NJ is a web application that provides users with real-time updates on local events, news, and community initiatives. I spearheaded the project’s frontend development, using React and Redux to create a dynamic, interactive interface. By integrating Node.js and Express.js on the backend, I ensured reliable data retrieval and seamless user interactions, delivering a platform that keeps users informed and engaged with their community.',
    // },
    // {
    //   name: 'Harisumiran TX',
    //   logo: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a8/3f/a1/a83fa1de-48a7-ca09-2f11-5c8509a35c00/AppIcon-0-0-1x_U007emarketing-0-6-0-85-220.png/230x0w.webp',
    //   technologies: ['React', 'Redux', 'Node.js', 'Express.js', 'MongoDB'],
    //   description:
    //     'Harisumiran TX is a full-stack application that connects users with local events, news, and community resources in Texas. I led the frontend development, using React and Redux to build a responsive, engaging user interface. By implementing Node.js and Express.js on the backend, I established secure data handling and authentication features, ensuring users can access relevant, up-to-date information about their community.',
    // },
  ],
};

export const aiStack = [
  {
    name: 'OpenAI',
    logo: 'https://github.gallerycdn.vsassets.io/extensions/github/copilotvs/1.206.0.0/1719349649662/Microsoft.VisualStudio.Services.Icons.Default',
    link: 'https://copilot.github.com/',
    description:
      'OpenAI is a research lab that focuses on building safe and useful AI.',
  },
  {
    name: 'Warp',
    logo: 'https://ph-files.imgix.net/02a2dbcc-3c93-40eb-85d9-2b5b77411b8c.png?auto=format',
    link: 'https://www.warp.dev/',
    description:
      'Warp is a modern, fast, and secure runtime for building AI applications.',
  },
  {
    name: 'Cursor',
    logo: 'https://www.cursor.com/apple-touch-icon.png',
    link: 'https://www.cursor.com/',
    description:
      'Cursor is a modern, fast, and secure runtime for building AI applications.',
  },
  {
    name: 'ChatGPT',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/ChatGPT_logo.svg/512px-ChatGPT_logo.svg.png',
    link: 'https://chatgpt.com/',
    description:
      'ChatGPT is a modern, fast, and secure runtime for building AI applications.',
  },
  {
    name: 'Claude',
  },
];
